export enum UnitType {
  SOLID = 'SOLID',
  LIQUID = 'LIQUID',
  PIECE = 'PIECE',
}

export enum UnitOfMeasureLabels {
  // Solid measures
  POUND = 'POUND',
  OUNCE = 'OUNCE',
  GRAMS = 'GRAMS',

  // Liquid measures (volume)
  CUP = 'CUP', // Base unit for liquids
  GALLON = 'GALLON',
  QUART = 'QUART',
  PINT = 'PINT',
  LIQUID_OUNCE = 'LIQUID_OUNCE',
  TABLESPOON = 'TABLESPOON',
  TEASPOON = 'TEASPOON',
  LITER = 'LITER',
  MILLILITER = 'MILLILITER',

  // Piece/Each measures
  PIECE = 'PIECE',
  SLICE = 'SLICE',
  EACH = 'EACH',

  // Special measures
  CUP_WEIGHT = 'CUP_WEIGHT',

  // Scoop measures
  SCOOP_6 = 'SCOOP_6',
  SCOOP_8 = 'SCOOP_8',
  SCOOP_10 = 'SCOOP_10',
  SCOOP_12 = 'SCOOP_12',
  SCOOP_16 = 'SCOOP_16',
  SCOOP_20 = 'SCOOP_20',
  SCOOP_24 = 'SCOOP_24',
  SCOOP_30 = 'SCOOP_30',
  SCOOP_40 = 'SCOOP_40',
  SCOOP_50 = 'SCOOP_50',
  SCOOP_60 = 'SCOOP_60',
  SCOOP_70 = 'SCOOP_70',
  SCOOP_100 = 'SCOOP_100',

  // Ladle measures
  LADLE_1_OZ = 'LADLE_1_OZ',
  LADLE_2_OZ = 'LADLE_2_OZ',
  LADLE_3_OZ = 'LADLE_3_OZ',
  LADLE_4_OZ = 'LADLE_4_OZ',
  LADLE_5_OZ = 'LADLE_5_OZ',
  LADLE_6_OZ = 'LADLE_6_OZ',
  LADLE_8_OZ = 'LADLE_8_OZ',
  LADLE_12_OZ = 'LADLE_12_OZ',
}

export const CONVERSION_CONSTANTS = {
  // Solid conversions
  POUND_TO_OUNCE: 16,
  POUND_TO_GRAMS: 453.592,
  OUNCE_TO_GRAMS: 28.3495,

  // Liquid conversions (to/from cups)
  GALLON_TO_CUP: 16,
  QUART_TO_CUP: 4,
  PINT_TO_CUP: 2,
  CUP_TO_LIQUID_OUNCE: 8,
  CUP_TO_TABLESPOON: 16,
  CUP_TO_TEASPOON: 48,
  LITER_TO_CUP: 4.227,
  MILLILITER_TO_CUP: 0.00422675,

  // Scoop conversions (to cups)
  SCOOP_TO_CUP: {
    SCOOP_6: 0.67,
    SCOOP_8: 0.5,
    SCOOP_10: 0.38,
    SCOOP_12: 0.33,
    SCOOP_16: 0.25,
    SCOOP_20: 0.2,
    SCOOP_24: 0.1667,
    SCOOP_30: 0.133,
    SCOOP_40: 0.1,
    SCOOP_50: 0.08,
    SCOOP_60: 0.0667,
    SCOOP_70: 0.057,
    SCOOP_100: 0.04,
  },

  // Ladle conversions (to cups)
  LADLE_TO_CUP: {
    LADLE_1_OZ: 0.13,
    LADLE_2_OZ: 0.25,
    LADLE_3_OZ: 0.38,
    LADLE_4_OZ: 0.5,
    LADLE_5_OZ: 0.63,
    LADLE_6_OZ: 0.75,
    LADLE_8_OZ: 1,
    LADLE_12_OZ: 1.5,
  },
} as const;

export interface UnitMeasures {
  // Solid measures
  pound?: number;
  ounce?: number;
  grams?: number;

  // Liquid measures
  cup?: number;
  cupWeight?: number;

  // Piece measures
  pieces?: number;
}
